import Vue from 'vue'
//import VueJWT from 'vuejs-jwt'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router'
import store from './store'
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

Vue.config.productionTip = false
Vue.$cookies.config('30d')
new Vue({
  vuetify,
  router,
  store,
  VueCookies,
  render: h => h(App)
}).$mount('#app')
